import type { AplicarReferenciaObrasDialogProps } from "./types-aplicar-referencia-obras-dialog";
import { useAplicarReferenciaObrasDialog } from "./use-aplicar-referencia-obras-dialog";
import { AplicarReferenciaObrasDialogView } from "./view-aplicar-referencia-obras-dialog";

export function AplicarReferenciaObrasDialog(props: AplicarReferenciaObrasDialogProps) {
  const vm = useAplicarReferenciaObrasDialog(props);

  return vm.oferecido ? <AplicarReferenciaObrasDialogView {...vm} /> : null;
}

export type * from "./types-aplicar-referencia-obras-dialog";
